
const SvgClockIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99984 0.166504C2.78336 0.166504 0.166504 2.78336 0.166504 5.99984C0.166504 9.21632 2.78336 11.8332 5.99984 11.8332C9.21632 11.8332 11.8332 9.21632 11.8332 5.99984C11.8332 2.78336 9.21632 0.166504 5.99984 0.166504ZM5.99984 1.0415C8.74343 1.0415 10.9582 3.25624 10.9582 5.99984C10.9582 8.74343 8.74343 10.9582 5.99984 10.9582C3.25624 10.9582 1.0415 8.74343 1.0415 5.99984C1.0415 3.25624 3.25624 1.0415 5.99984 1.0415ZM5.5555 2.49357C5.43957 2.49538 5.32909 2.54314 5.24834 2.62634C5.1676 2.70955 5.12317 2.8214 5.12484 2.93734V6.14567C5.12486 6.26169 5.17096 6.37296 5.25301 6.455L6.71134 7.91333C6.75166 7.95532 6.79994 7.98884 6.85337 8.01193C6.90681 8.03502 6.96431 8.04722 7.02251 8.04781C7.08072 8.04841 7.13845 8.03738 7.19234 8.01538C7.24623 7.99338 7.29519 7.96084 7.33635 7.91968C7.37751 7.87852 7.41004 7.82957 7.43204 7.77568C7.45405 7.72179 7.46507 7.66405 7.46448 7.60585C7.46389 7.54764 7.45169 7.49014 7.4286 7.43671C7.40551 7.38328 7.37198 7.33499 7.33 7.29468L5.99984 5.96452V2.93734C6.00068 2.87878 5.98975 2.82065 5.96771 2.76639C5.94567 2.71214 5.91297 2.66286 5.87153 2.62147C5.83009 2.58009 5.78077 2.54745 5.72649 2.52548C5.6722 2.5035 5.61406 2.49266 5.5555 2.49357Z"
        className="fill-primary"
      />
    </svg>
  );
};

export default SvgClockIcon;
